import { useState } from "react";

// Import images
import w7_4 from "../assets/w7-4.jpg";
import w7_5 from "../assets/w7-5.jpg";
import w7_6 from "../assets/w7-6.jpg";
import w7_7 from "../assets/w7-7.jpg";
import w7_8 from "../assets/w7-8.jpg";
import w7_9 from "../assets/w7-9.jpg";
import w7_10 from "../assets/w7-10.jpg";
import w7_11 from "../assets/w7-11.jpg";
import w7_12 from "../assets/w7-12.jpg";
import w7_13 from "../assets/w7-13.jpg";
import w7_14 from "../assets/w7-14.jpg";
import w7_15 from "../assets/w7-15.jpg";
import w7_16 from "../assets/w7-16.jpg";
import w7_17 from "../assets/w7-17.jpg";

// Array of slides with alternating text and images
const slides = [
  { type: "text", title: "3D Design with Fusion 360", description: "" },
  { type: "image", src: w7_4 },

  { type: "text", title: "End to Face to Edge Joint", description: "Designing the part of the upper part of the joint. Don't forget to add the press-fit parameter" },
  { type: "image", src: w7_5 },
  { type: "text", title: " Use the Mirror Tool", description: "Use the mirror tool to place the elements along the two sides of the table" },
  { type: "image", src: w7_8 },


  { type: "text", title: "Table Top Sketch", description: "" },
  { type: "image", src: w7_9 },

  { type: "text", title: "Construction of End-To-Face Joints", description: "I used T-Bone fillets for the End-To-Face Joints" },
  { type: "image", src: w7_10 },



  { type: "text", title: "Construction of the table legs", description: "" },
  { type: "image", src: w7_13 },

  { type: "text", title: "All components at a glance...", description: "" },
  { type: "image", src: w7_14 },

  { type: "text", title: "Final Assembly using the align-tool", description: "" },
  { type: "image", src: w7_15 },

  { type: "text", title: "Detailed view of the End to Face to Edge Joints", description: "" },
  { type: "image", src: w7_16 },

  { type: "text", title: "Finished Project", description: "The final multifunctional table as a 3D Model." },
  { type: "image", src: w7_17 },
];

export default function ExplanatoryGallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="max-w-[800px] mx-auto mt-10">
      {/* Slide Content: Either Text or Image */}
      {slides[currentIndex].type === "text" ? (
        <div className="bg-gray-100 p-6 rounded-lg shadow-md flex items-center justify-center text-center w-full h-[400px]">
          <div>
            <h2 className="text-xl font-semibold mb-2">{slides[currentIndex].title}</h2>
            <p className="text-gray-600">{slides[currentIndex].description}</p>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-[400px]">
          <img
            src={slides[currentIndex].src}
            alt={`Slide ${currentIndex + 1}`}
            className="rounded-lg shadow-lg w-full h-full object-contain"
          />
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex justify-between mt-4">
        <button
          onClick={prevSlide}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          ◀ Previous
        </button>
        <button
          onClick={nextSlide}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          Next ▶
        </button>
      </div>

      {/* Indicator Dots */}
      <div className="flex justify-center mt-4 space-x-2">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === currentIndex ? "bg-gray-800" : "bg-gray-400"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}
